module.exports = __webpack_public_path__ + "img/bgc8.49eaecf3.png";